// Components==============
import React from 'react';
import './index.module.scss';
import { motion } from 'framer-motion';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
// =========================

export default function EventCard({ id, title, date }) {
    // format date
    const formattedDateDay = () => {
        const d = new Date(date).toLocaleDateString('nl-NL', {
            timeZone: 'Europe/Amsterdam',
            day: 'numeric',
        });
        // const day = d.getDate();
        return `${d}`;
    };

    /* get day of the week from date string */
    const getDayOfWeek = () => {
        const d = new Date(date);
        const dayOfWeek = new Intl.DateTimeFormat('nl-NL', {
            timeZone: 'Europe/Amsterdam',
            weekday: 'long',
        }).format(d);
        return dayOfWeek;
    };

    const openEventModal = useOpenUrlModal(`event-popup/${id}`);

    return (
        <motion.div
            onClick={() => openEventModal()}
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.95 }}
            styleName="wrapper"
        >
            <div styleName="date ">
                <p styleName="dayWeek">
                    {getDayOfWeek(date).toUpperCase().slice(0, 2)}
                </p>
                <p styleName="dateDay">{formattedDateDay(date)}</p>
            </div>
            <div styleName="title">
                <p>{title}</p>
            </div>
        </motion.div>
    );
}
